const textConstants = {
  notAvailaible: 'N/A',
  noInfoText: 'Não informado',
};

export { textConstants };
